import React from 'react';

import { Breadcrumbs } from 'uikit/layouts';

import { registerField } from 'core/forms';

const FormFieldBreadcrumbs = ({
  schema,
}) => (
  <Breadcrumbs
    breadcrumbs={schema.breadcrumbs}
  />
);

registerField('Breadcrumbs', React.memo(FormFieldBreadcrumbs));

export default FormFieldBreadcrumbs;
